import { useState } from 'react'

import { useTheme } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import Link from 'components/common/A'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import { useArticleClassifications } from 'utils/api/hooks'

const ArticleClassifications = ({ articleClassificationItem }) => {
  const theme = useTheme()
  const [inHover, setInHover] = useState(false)

  return (
    <Grid item xs={6} md={4} lg={6}>
      <Link
        href={`/article-classification/${articleClassificationItem?.urlId}`}
      >
        <Box
          display="flex"
          alignItems="center"
          onMouseEnter={() => setInHover(true)}
          onMouseLeave={() => setInHover(false)}
        >
          <Typography
            color={inHover ? theme.palette.primary.main : 'text.minus2'}
          >
            {articleClassificationItem.name}
          </Typography>
          <Typography
            color={inHover ? theme.palette.primary.minus2 : 'textSecondary'}
            ml={1}
          >
            {`(${articleClassificationItem.articles?.length})`}
          </Typography>
        </Box>
      </Link>
    </Grid>
  )
}

const ArticleClassificationList = (props) => {
  const { data: articleClassifications } = useArticleClassifications({
    isGetArticles: true,
  })

  const showArticleClassifications = articleClassifications?.filter(
    (item) => item.articles?.length > 0
  )

  return (
    <Box {...props}>
      <Typography mb={6} fontWeight="fontWeightBold">
        文章分類
      </Typography>
      <Grid container spacing={4}>
        {showArticleClassifications &&
          showArticleClassifications.map((item, index) => {
            return (
              <ArticleClassifications
                key={`item-${index}`}
                articleClassificationItem={item}
              />
            )
          })}
      </Grid>
    </Box>
  )
}

export default ArticleClassificationList
